import React, { Fragment, useEffect, useState } from "react";
import { Row, Col, Button, Form, FloatingLabel, Alert } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCirclePlus } from '@fortawesome/free-solid-svg-icons'
import Local from './locais'
import '../../../../../../styles/diario.scss';
import SaudeService from "../../../../../../services/saude-auth";

const Profissional = (props) => {
    const id = props.profissional
    const [nome, setNome] = useState("");
    const [especialidade, setEspecialidade] = useState("");
    const [localId, setLocalId] = useState("")
    const [dia, setDia] = useState("")
    const [locais, setLocais] = useState("")
    const [horarios, setHorarios] = useState("")
    const [searchText, setSearchText] = useState("");
    const [filteredLocais, setFilteredLocais] = useState([]);
    const [error, setError] = useState([]);

    async function fetchProfissional(id) {
        var response = await SaudeService.saudeEditProfissionais(id);
        if (response.data["locais"]) {
            setLocais(response.data["locais"])
        }
        setNome(response.data["nome"]);
        setEspecialidade(response.data["especialidade"]);
    }

    useEffect(() => {
        fetchProfissional(id);
    }, [id]);

    const deletarLocal = async (profissional, id) => {
        if (window.confirm('Tem certeza que deseja excluir o Local e Horário de Atendimento do Profissional?')) {
            try {
                await SaudeService.deletarLocal(profissional, { local: id })
                alert("Local e Horários retirados com sucesso!")
                fetchProfissional(profissional);
            } catch (err) {
                alert("Algo deu errado ao retirar o produto!")
            }
        }
    }


    const handleCancelar = (e) => {
        e.preventDefault();
        props.setVer(false)
    }


    const HandleSubmit = async (e) => {
        e.preventDefault()
        try {
            const local = await SaudeService.locais(id, {
                local: localId,
                dia: dia,
                horarios: horarios
            })
            setError(false)
            alert("Locais e Horários atualizados com sucesso!")
            setSearchText("")
            setHorarios("")
            setDia("")
            fetchProfissional(id)
        } catch (error) {
            setError("Deu algo errado na sua edição!")
        }
    }

    const handleSearch = (e) => {
        const searchText = e;
        setSearchText(searchText);

        // Filtrar os locais com base no texto digitado
        const filtered = props.locais.filter((local) =>
            local.nome.toLowerCase().includes(searchText.toLowerCase())
        );
        setFilteredLocais(filtered);
    };


    return (
        <Fragment>
            <Row>
                <h1>#{nome} - {especialidade}</h1>
                <Form onSubmit={HandleSubmit} >
                    <Row xs={4} lg={4}>
                        <Col lg={5}>
                            <Form.Group className="mb-3" controlId="locais">
                                <FloatingLabel
                                    label="Local de Atendimento"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        type="text"
                                        name="searchText"
                                        value={searchText}
                                        onChange={(e) => handleSearch(e.target.value)}
                                    />
                                    <Form.Select
                                        required
                                        aria-label="Local"
                                        name="local"
                                        onChange={e => setLocalId(e.target.value)}
                                    >
                                        <option>SELECIONE</option>
                                        {filteredLocais
                                            .map((local) => (
                                                <option key={local._id} value={local.nome}>
                                                    {local.nome}
                                                </option>
                                            ))}
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col lg={2}>
                            <Form.Group className="mb-3" controlId="Dia da Semana">
                                <FloatingLabel
                                    label="Dia da Semana"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Dia da Semana"
                                        name="dia"
                                        onChange={e => setDia(e.target.value)}
                                    >
                                        <option>SELECIONE</option>
                                        <option value="Segunda-feira">Segunda-feira</option>
                                        <option value="Terça-feira">Terça-feira</option>
                                        <option value="Quarta-feira">Quarta-feira</option>
                                        <option value="Quinta-feira">Quinta-feira</option>
                                        <option value="Sexta-feira">Sexta-feira</option>
                                        <option value="Sábado">Sábado</option>
                                        <option value="Domingo">Domingo</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col lg={2}>
                            <Form.Group className="mb-3" controlId="horarios">
                                <FloatingLabel
                                    label="Horários"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        type="text"
                                        name="horarios"
                                        value={horarios}
                                        onChange={e => setHorarios(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                        <Col lg={1}>
                            <Button variant="success" type="submit">
                                <FontAwesomeIcon icon={faCirclePlus} />
                            </Button>
                        </Col>
                    </Row>
                </Form >
            </Row>
            {locais ?
                <Fragment>
                    <Row xs={9} lg={9}>
                        <Col xs={3} lg={5}>
                            <p>Local</p>
                        </Col>
                        <Col xs={3} lg={2}>
                            <p>Dia</p>
                        </Col>
                        <Col xs={2}>
                            <p>Horário</p>
                        </Col>
                    </Row>
                    {locais.map((local, index) =>
                        <Local
                            profissional={id}
                            local={local}
                            fetchProfissional={fetchProfissional}
                            deletar={deletarLocal}
                        />
                    )}
                </Fragment>
                : ''}
            <Button onClick={(e) => handleCancelar(e)} variant="danger" type="button">
                Voltar
            </Button>

        </Fragment >
    )
}

export default Profissional;